import { render, staticRenderFns } from "./WatermarkAdd.vue?vue&type=template&id=095739ff"
import script from "./WatermarkAdd.vue?vue&type=script&lang=js"
export * from "./WatermarkAdd.vue?vue&type=script&lang=js"
import style0 from "./WatermarkAdd.vue?vue&type=style&index=0&id=095739ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports